/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  CreateVariantMutationRequest,
  CreateVariantMutationResponse,
  CreateVariant400,
} from '../types/CreateVariant'

function getCreateVariantUrl() {
  const res = {
    method: 'POST',
    url: `/api/v1/products/catalog/variants/` as const,
  }
  return res
}

/**
 * @description Create a new variant.
 * POST /variants/
 * Body:
 * Variant data (name, sku, gtin, format_pack_size, weights, etc.)
 * Returns:
 * Response with created variant data or error
 * @summary Create a new variant
 * {@link /api/v1/products/catalog/variants/}
 */
export async function createVariant(
  data: CreateVariantMutationRequest,
  config: Partial<RequestConfig<CreateVariantMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    CreateVariantMutationResponse,
    ResponseErrorConfig<CreateVariant400>,
    CreateVariantMutationRequest
  >({
    method: 'POST',
    url: getCreateVariantUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
